module.exports = __webpack_public_path__ + "img/600.5fde6e0e.jpg";